import React,{ useState,useEffect } from 'react';
import styled from 'styled-components';
import {  useHistory } from 'react-router-dom';
import { If, Then, Else} from 'react-if';
import { useForm } from 'react-hook-form';


import { useQuery, useMutation } from '@apollo/client';

// Components
import StyledPageContent from '../components/StyledPage';
import Contenedor from '../components/Contenedor';
import Loading from '../components/Loading';
import { TableStyled } from '../components/TableStyled';

import AcreditacionProfile from '../models/AcreditacionProfile';
import { GET_PROFILE_POINTS_TOTAL_AND_LIST_PRODUCTS } from '../models/AcreditacionProfilePoints';
import { CREATE_PROFILE_POINTS_ORDERS } from '../models/AcreditacionProfileOrders';



const moment = require('moment-timezone').tz.setDefault('America/Mexico_City')
moment.locale('es');

const StyledPage = styled(StyledPageContent)`
  .photo-input-file-wrapper {
    margin-top: 2rem
  }
`

const ContenedorStyled=styled(Contenedor)`
    display: flex;
    flex-wrap: wrap;
    .tit-puntos{
        font-size:1.2rem;
        font-weight:bold;
        color:var(--color-blue);
    }
    .tit-cantidad{
        font-size:1.2rem;
        font-weight:bold;
        color:var(--color-rojo);
    }
    .list-puntos-pendientes{
        h6{
            color:var(--color-azul);
        }
        color:var(--color-azul);
        ul{
            list-style: none !important;
            li{
                padding:0px;
                margin:0px;
                text-align: center;
            }
        }
    }

`;



const StyleTextAddicional=styled.div`
    margin-bottom:40px;
    p{
        font-size:13px;
    }
    textarea{
        width: 100%;
        height:50px;
    }
`;



export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();
  
    const { loading, error, data, refetch } = useQuery(GET_PROFILE_POINTS_TOTAL_AND_LIST_PRODUCTS,{
        variables:{
            profile_uuid:UserInfo.uuid,
            status:'PROCESSING_PAID'
        }
    });

    if(loading)
        return <Loading />

    let totalPoints=data.getAcreditacionProfilePointsTotal;

    const RowRedimir= ({item}) => {
        const [ canjearPuntos, {loading} ] = useMutation(CREATE_PROFILE_POINTS_ORDERS);
        const [showText,setShowText] = useState<boolean>(false);

        const { register, handleSubmit, watch, errors:errors_fomr } = useForm({
            defaultValues:(process.env.NODE_ENV==='development')?{
            }:{}
        });

        const clickCanejo=async (data:any) => {
            if(!confirm(`¿Seguro que desea utilizar ${new Intl.NumberFormat('en-US').format(item.amount)} puntos para "${item.name}" `)) return true;

            try{
                let response=await canjearPuntos({ 
                    variables:{
                        profile_uuid:UserInfo.uuid,
                        item:item.id,
                        text_adicional:data.text_adicional || ''
                    },
                    context:{
                        headers:{
                            'x-recapchatoken':''
                        }
                    }                
                });
    

                if(response.errors)
                    throw new Error(response.errors[0]?.message);

                await refetch();
                
            }catch(e){
                alert(e.message);
            }
        };

        const onSubmit= async (data:any) => {
            await clickCanejo(data);
        }

        return (
            <>
                <tr>
                    <td>{item.name}</td>
                    <td className="text-center">{new Intl.NumberFormat('en-US').format(item.amount)}</td>
                    <td className="text-center">
                        <If condition={item.text_adicional}>
                            <Then>
                                {!showText  &&
                                    <button className="bg-red" disabled={totalPoints<item.amount} onClick={()=> setShowText(true)}>CONTINUAR</button>
                                }
                            </Then>
                            <Else>
                                <button className="bg-red" disabled={loading || totalPoints<item.amount} onClick={clickCanejo}>CANJEAR</button>
                            </Else>
                        </If>
                    </td>
                </tr>
                {showText &&
                <tr>
                    <td colSpan={3}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <StyleTextAddicional>
                                <p>{item.text_adicional}</p>
                                <textarea placeholder='Describir el motivo del mensaje.' name="text_adicional" required  ref={register}></textarea>
                                <button  type="submit" className="bg-red" disabled={loading} >CANJEAR</button>
                            </StyleTextAddicional>
                        </form>
                    </td>
                </tr>
                }
            </>
        );
    };

    return (
        <StyledPage>
            <ContenedorStyled>
                <div className="col-12">
                    <p>Querido abonad@,</p>

                    <p>Como parte de tus beneficios exclusivos, tenemos diferentes actividades en las cuales puedes conseguir puntos recompensa e intercambiarlos por experiencias únicas. El total de tus puntos es un acumulado de todos los abonos dentro de tu cuenta.</p> 

                    <p>Si tienes alguna duda acerca de tus puntos o de como utilizarlos, mándanos un correo a <a href="mailto:abonados@atleticodesanluis.mx">abonados@atleticodesanluis.mx</a> o escríbenos vía Whatsapp al <a href="tel:4441118872"></a>444-111-8872.</p>
                </div>
                <div className="col-12 text-center">
                    <p className='tit-puntos'>
                        {UserInfo.email}<br />
                        MIS PUNTOS DISPONIBLES: <span className='tit-cantidad'>{new Intl.NumberFormat('en-US').format(totalPoints)}</span>
                    </p>
                </div>
                <If condition={data?.listProfilePointsOrders?.edge?.length>0}>
                    <Then>
                        <div className="col-12 text-center list-puntos-pendientes">
                            <h6>PUNTOS EN PROCESO:</h6>
                            <ul>
                                {data?.listProfilePointsOrders?.edge?.map( item => (
                                    <li>
                                        {new Intl.NumberFormat('en-US').format(item.amount)} ({item.AcreditacionesProfilesPointsProducts?.name}, {moment(item.created_at).format('DD/MM/YYYY')})
                                    </li>
                                ))}
                            </ul>
                            <br />
                        </div>
                    </Then>
                </If>

                <TableStyled className="col-12">
                    <div className="tit-table">¿CÓMO PUEDO UTILIZAR MIS PUNTOS?</div>
                    <table className="table-formate">
                        <thead>
                            <tr>
                                <th>EXPERIENCIA</th>
                                <th className="text-center">PUNTOS</th>
                                <th className="text-center">ACCIÓN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.listProfilePointsProducts?.edge?.map( item => (
                                <RowRedimir item={item} />
                            ))}
                        </tbody>
                    </table>
                </TableStyled>
                
                <TableStyled className="col-12 mt-5">
                    <div className="tit-table">¿CÓMO PUEDO OBTENER PUNTOS RECOMPENSA?</div>
                    <table className="table-formate">
                        <thead>
                            <tr>
                                <th>ACTIVIDAD</th>
                                <th className="text-center">PUNTOS</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Renovación/Compra de Abono Anual</td>
                                <td className="text-center">20</td>
                            </tr>
                            <tr>
                                <td>Ingreso de 2 a 1 hora antes del juego</td>
                                <td className="text-center">15</td>
                            </tr>
                            <tr>
                                <td>Compra de 1 boleto adicional durante la preventa (no aplica partidos AAA)</td>
                                <td className="text-center">10</td>
                            </tr>
                            <tr>
                                <td>Compra de $100 pesos en la Tienda en Línea ADSL</td>
                                <td className="text-center">10</td>
                            </tr>
                            <tr>
                                <td>Asistencia del 100% durante un torneo</td>
                                <td className="text-center">50</td>
                            </tr>
                            <tr>
                                <td>Ganar una dinámica en redes sociales ADSL</td>
                                <td className="text-center">50</td>
                            </tr>
                            <tr>
                                <td>Ingresar al portal de abonados</td>
                                <td className="text-center">5</td>
                            </tr>
                            <tr>
                                <td>Asistir al Dia del Abonado</td>
                                <td className="text-center">20</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-right pr-1">
                        <br />
                        * Todos los puntos obtenidos se añadirán a tu cuenta al final de cada mes<br />
                        * Entrega de experiencias y premios en tiempo/día de mutuo acuerdo<br />
                        * Puntos no acumulables año con año<br />
                        * Cambios en lineamientos de puntuación, sujeto a disponibilidad<br />
                    </div>
                </TableStyled>

            </ContenedorStyled>
        </StyledPage>
    )
}
